import { getTextDirection } from '@wix/ricos';

export const isTextDirectionRTL = (text: string) => getTextDirection(text) === 'rtl';
